module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"global":"Weltweit","globalText":"Unser guter Ruf als Montagetischler eilt uns nicht nur voraus, sondern bringt uns für unsere Einsätze an die spannendsten Orte der Welt."},"en":{"global":"Global","globalText":"Our good reputation not only speaks for itself, but it brings us installation jobs in some of the most exciting places on earth."}}')
  delete Component.options._Ctor
}
